<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <h6 class="text-muted text-uppercase small mb-2">{{ generalSectionTitle }}</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="damageKind">Kind <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.damageKind"
                        name="damageKind"
                        id="damageKind"
                        [itemsSource]="damageKindList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        [isEditable]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="incidentDateTime">Date &amp; Time of Incident <span class="text-danger">*</span></label>
                    <wj-input-date-time
                        [(ngModel)]="target.incidentDateTime"
                        name="incidentDateTime"
                        id="incidentDateTime"
                        [isRequired]="true"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="reportedByUserId">Reported By <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.reportedByUserId"
                        name="reportedByUserId"
                        id="reportedByUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="telephoneNumber">Telephone Number</label>
                    <input
                        type="text"
                        class="form-control"
                        id="telephoneNumber"
                        name="telephoneNumber"
                        [(ngModel)]="target.telephoneNumber"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="location">Location of Damage (City, Street Name or Number)</label>
                    <app-voice-text-field
                        [(ngModel)]="target.location"
                        name="location"
                        inputId="location"
                        [rows]="2"
                        [showLocationButton]="true"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="foremanSuperintendent">Foreman or Superintendent</label>
                    <input
                        type="text"
                        class="form-control"
                        id="foremanSuperintendent"
                        name="foremanSuperintendent"
                        [(ngModel)]="target.foremanSuperintendent"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="assetNumber">{{ assetNumberLabel }}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="assetNumber"
                        name="assetNumber"
                        [(ngModel)]="target.assetNumber"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="dotClassification">DOT / Non-DOT</label>
                    <wj-combo-box
                        [(ngModel)]="target.dotClassification"
                        name="dotClassification"
                        id="dotClassification"
                        [itemsSource]="dotClassificationList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isEditable]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-check mt-4">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="drugTestPerformed"
                        name="drugTestPerformed"
                        [(ngModel)]="target.drugTestPerformed"
                    />
                    <label class="form-check-label" for="drugTestPerformed">Drug Test Performed</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-check mb-2">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="anyoneInjured"
                        name="anyoneInjured"
                        [(ngModel)]="target.anyoneInjured"
                    />
                    <label class="form-check-label" for="anyoneInjured">Was anyone injured?</label>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuredWho">Who was injured?</label>
                    <input
                        type="text"
                        class="form-control"
                        id="injuredWho"
                        name="injuredWho"
                        [(ngModel)]="target.injuredWho"
                        [disabled]="!target.anyoneInjured"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="typeOfInjuries">Type of Injury? (Sprain/Strain, Fracture, Contusion, Laceration)</label>
                    <app-voice-text-field
                        [(ngModel)]="target.typeOfInjuries"
                        name="typeOfInjuries"
                        inputId="typeOfInjuries"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-check mb-2">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="anyoneTransported"
                        name="anyoneTransported"
                        [(ngModel)]="target.anyoneTransported"
                    />
                    <label class="form-check-label" for="anyoneTransported">Was anyone transported?</label>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="transportedWhere">Where were they transported?</label>
                    <input
                        type="text"
                        class="form-control"
                        id="transportedWhere"
                        name="transportedWhere"
                        [(ngModel)]="target.transportedWhere"
                        [disabled]="!target.anyoneTransported"
                    />
                </div>
            </div>
        </div>

        @if (isVehicle) {
            <div class="row">
                <div class="col-12">
                    <div class="form-check mb-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="involvesThirdParty"
                            name="involvesThirdParty"
                            [(ngModel)]="target.involvesThirdParty"
                        />
                        <label class="form-check-label" for="involvesThirdParty">Does it involve a Third Party?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="thirdPartyInformation">Third Party Information</label>
                        <app-voice-text-field
                            [(ngModel)]="target.thirdPartyInformation"
                            name="thirdPartyInformation"
                            inputId="thirdPartyInformation"
                            [rows]="3"
                        ></app-voice-text-field>
                    </div>
                </div>
            </div>
        }

        <hr />
        <h6 class="text-muted text-uppercase small mb-2">{{ detailsSectionTitle }}</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-check mb-2">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="photosTakenAttached"
                        name="photosTakenAttached"
                        [(ngModel)]="target.photosTakenAttached"
                    />
                    <label class="form-check-label" for="photosTakenAttached">Photos Taken / Attached?</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="detailsOfWhatHappened">
                        Details of what happened
                        @if (isVehicle) {
                            <span class="text-danger">*</span>
                        }
                    </label>
                    <app-voice-text-field
                        [(ngModel)]="target.detailsOfWhatHappened"
                        name="detailsOfWhatHappened"
                        inputId="detailsOfWhatHappened"
                        [rows]="3"
                    ></app-voice-text-field>
                    @if (isVehicle) {
                        <input
                            type="hidden"
                            name="detailsOfWhatHappenedRequired"
                            [ngModel]="target.detailsOfWhatHappened"
                            required
                        />
                    }
                </div>
            </div>
        </div>

        @if (isVehicle) {
            <div class="row">
                <div class="col-sm-6 col-md-3 col-12">
                    <div class="form-check mb-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="policeDispatched"
                            name="policeDispatched"
                            [(ngModel)]="target.policeDispatched"
                        />
                        <label class="form-check-label" for="policeDispatched">Police Dispatched</label>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 col-12">
                    <div class="form-check mb-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="fireDispatched"
                            name="fireDispatched"
                            [(ngModel)]="target.fireDispatched"
                        />
                        <label class="form-check-label" for="fireDispatched">Fire Dispatched</label>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 col-12">
                    <div class="form-check mb-2">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="emsDispatched"
                            name="emsDispatched"
                            [(ngModel)]="target.emsDispatched"
                        />
                        <label class="form-check-label" for="emsDispatched">EMS Dispatched</label>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 col-12">
                    <div class="form-group">
                        <label for="policeCaseNumber">Police Case Number</label>
                        <input
                            type="text"
                            class="form-control"
                            id="policeCaseNumber"
                            name="policeCaseNumber"
                            [(ngModel)]="target.policeCaseNumber"
                        />
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="investigationRevealed">Investigation Revealed</label>
                    <app-voice-text-field
                        [(ngModel)]="target.investigationRevealed"
                        name="investigationRevealed"
                        inputId="investigationRevealed"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="disciplinaryActionGiven">Disciplinary Action Given</label>
                    <app-voice-text-field
                        [(ngModel)]="target.disciplinaryActionGiven"
                        name="disciplinaryActionGiven"
                        inputId="disciplinaryActionGiven"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="correctiveAction">Corrective Action</label>
                    <app-voice-text-field
                        [(ngModel)]="target.correctiveAction"
                        name="correctiveAction"
                        inputId="correctiveAction"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="employeeSignature">Employee Signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="employeeSignature"
                        name="employeeSignature"
                        [(ngModel)]="target.employeeSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="signedOn">Signed On</label>
                    <wj-input-date-time [(ngModel)]="target.signedOn" name="signedOn" id="signedOn" [isRequired]="false"></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <app-voice-text-field [(ngModel)]="target.notes" name="notes" inputId="notes" [rows]="2"></app-voice-text-field>
                </div>
            </div>
        </div>

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attachments</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingFileSrc(url)"
                            (click)="openExistingFile(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (attachments && attachments.length > 0) {
            <div class="row">
                <label>Files To Upload</label>
                @for (file of attachments; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeAttachment(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="getPendingFileSrc(file)" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Photos / Documents</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
